import I18n from '@src/i18n';
import styled from '@src/styled-components';
import React from 'react';
import ReactQuill from 'react-quill';

import AppContext from '../services/Context';

const modules = {
    toolbar: [
        [{ size: ['small', false, 'large', 'huge'] }],
        ['bold', 'italic'],
    ],
};

const formats = [
    'size',
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet', 'indent',
    'link', 'image',
]

type PropType = {
    onTextChange: any;
    placeholder?: string;
    title?: string;
    description?: string;
    defaultValue?: string;
    locale?: string;
    height?: string;
};
type StateType = {};

/* 
 * Editor component with custom toolbar and content containers
 */
class QuillHtmlComponent extends React.Component<PropType, StateType> {

    private reactQuillRef: any;
    static modules: any;
    static formats: any;

    constructor(props: any) {
        super(props);
        this.reactQuillRef = null
        this.state = { editorHtml: "" };
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(html: any) {
        // this.props.onTextChange(html);
        this.setState({ editorHtml: html });
    }

    componentDidUpdate() {
        if (!!this.reactQuillRef) {
            if (!!this.reactQuillRef.getEditor()) {
                if (!!this.reactQuillRef.getEditor().root) {
                    this.reactQuillRef.getEditor().root.setAttribute('data-placeholder', this.props.placeholder || "");
                }
            }
        }
    }

    render() {
        return (
            <AppContext.Consumer>
                {({ locale, theme }) => (
                    <QuillWrapper height={this.props.height} lang={localStorage.getItem("locale") || 'en'} >
                        {!!this.props.title && (
                            <p className="title">{this.props.title}</p>
                        )}
                        {!!this.props.description && (
                            <p className='description'>{this.props.description}</p>
                        )}
                        <ReactQuill
                            ref={(el) => { this.reactQuillRef = el }}
                            defaultValue={this.props.defaultValue}
                            onChange={this.props.onTextChange}
                            placeholder={this.props.placeholder}
                            modules={modules}
                            formats={formats}
                        />
                    </QuillWrapper>
                )}
            </AppContext.Consumer>
        );
    }
}

const QuillWrapper = styled.div`
    .title{
        font-weight: bold;
    }
    .description{
        width: 60%;
        margin-bottom: 1rem;
    }
    .ql-snow {
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
    }

    .ql-toolbar.ql-snow + .ql-container.ql-snow{
        width:100%;
        height: ${props => props.height || '150px'};
        border-top-left-radius: 0px;
        border-top-right-radius: 0px;
        border-bottom-right-radius: 5px;
        border-bottom-left-radius: 5px;
    }
    .ql-snow {
        .ql-picker.ql-size {
            .ql-picker-item[data-value=small]::before {
                content: "${() => I18n.l('richText.size.small')}";
            }
            .ql-picker-label[data-value=small]::before{
                content: "${() => I18n.l('richText.size.small')}";
            }
            .ql-picker-item[data-value=large]::before {
                content: "${() => I18n.l('richText.size.large')}";
            }
            .ql-picker-label[data-value=large]::before{
                content: "${() => I18n.l('richText.size.large')}";
            }
            .ql-picker-item[data-value=huge]::before {
                content: "${() => I18n.l('richText.size.huge')}";
            }
            .ql-picker-label[data-value=huge]::before{
                content: "${() => I18n.l('richText.size.huge')}";
            }
        }
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before

    .ql-snow .ql-picker.ql-header .ql-picker-label::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item::before {
        content: 'Normal';
    }
}
`

export default QuillHtmlComponent;